export default __webpack_public_path__ + "static/media/myFace1.79a0a2cf.jpg";